import React, { createContext } from 'react';
import { MarketLocaleType } from '../types/administrationTypes';
import { RecordLocator } from '@tff/types';

interface Props {
  children: React.ReactNode;
  marketLocale: MarketLocaleType;
  currency: string | undefined;
  recordLocator?: RecordLocator;
}

export const BookingContext = createContext({
  costFormatter: new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR',
  }),
  currency: 'EUR',
  numberFormatter: new Intl.NumberFormat('de-DE', {
    minimumFractionDigits: 2,
  }),
  decimalSeparator: ',',
  allowedCharsRegex: new RegExp(`[^0-9,]`, 'g'),
  recordLocator: undefined as RecordLocator | undefined,
});

const BookingContextProvider = ({ marketLocale, children, currency = 'EUR', recordLocator }: Props) => {
  const costFormatter: Intl.NumberFormat = new Intl.NumberFormat(marketLocale, {
    style: 'currency',
    currency: currency,
  });

  const numberFormatter: Intl.NumberFormat = new Intl.NumberFormat(marketLocale, {
    minimumFractionDigits: 2,
  });

  const decimalSeparator =
    marketLocale.startsWith('de') ||
    marketLocale.startsWith('fr') ||
    marketLocale.startsWith('es') ||
    marketLocale.startsWith('it')
      ? ','
      : '.';
  const allowedCharsRegex = new RegExp(`[^0-9${decimalSeparator.replace('.', '\\.')}]`, 'g');

  const value = {
    costFormatter,
    currency,
    numberFormatter,
    decimalSeparator,
    allowedCharsRegex,
    recordLocator,
  };

  return <BookingContext.Provider value={value}>{children}</BookingContext.Provider>;
};

export default BookingContextProvider;
